import { ActionType, createAsyncAction } from "typesafe-actions";

import {
  FieldAgentBriefEntityType,
  FieldAgentRecordBrief,
} from "@mapmycustomers/shared/types/chat/FieldAgentChat";
import { FiCatalogResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";
import { AnyEntityId } from "@mapmycustomers/shared/types/entity/types";

export const fetchRecordBrief = createAsyncAction(
  "@component/recordBrief/fetchRecordBrief/request",
  "@component/recordBrief/fetchRecordBrief/success",
  "@component/recordBrief/fetchRecordBrief/failure"
)<
  { entityType: FieldAgentBriefEntityType; forceRefresh?: boolean; recordId: AnyEntityId },
  FieldAgentRecordBrief,
  unknown
>();

export const fetchRecordChartCatalog = createAsyncAction(
  "@component/recordBrief/fetchRecordChartCatalog/request",
  "@component/recordBrief/fetchRecordChartCatalog/success",
  "@component/recordBrief/fetchRecordChartCatalog/failure"
)<void, FiCatalogResponse[], unknown>();

export type Actions = ActionType<typeof fetchRecordBrief | typeof fetchRecordChartCatalog>;
